import { Checkbox } from '@zoopla-eng/zds-components/checkbox';
import { Stack } from '@zoopla-eng/zds-components/stack';
import { getPropertyType } from '@zoopla/listing-search/get-property-type';
import {
    FilterWrapper,
    PropertyTypeFilterLabel
} from './SearchInitiationMobile.styles';

const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

const propertySubTypeOptions = {
    detached: 'Detached',
    semi_detached: 'Semi-detached',
    terraced: 'Terraced',
    flats: 'Flats',
    bungalow: 'Bungalows',
    farms_land: 'Farms/land',
    park_home: 'Park homes'
};

export type PropertyType = typeof propertyTypes[number];
export type PropertySubType = Array<keyof typeof propertySubTypeOptions>;

type SelectPropertyTypeProps = {
    value: { propertyType: PropertyType; propertySubType: PropertySubType };
    onChange: ({
        propertySubType,
        propertyType
    }: {
        propertySubType: PropertySubType;
        propertyType: PropertyType;
    }) => void;
};

export const SelectPropertyType = ({
    value,
    onChange
}: SelectPropertyTypeProps) => {
    const propertyTypeLabel = 'Property type';

    return (
        <FilterWrapper>
            <PropertyTypeFilterLabel htmlFor="modal-property-type-filter">
                {propertyTypeLabel}
            </PropertyTypeFilterLabel>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                columnGap="0"
                rowGap="$S400"
                items={{
                    width: '50%'
                }}
            >
                {[
                    <Checkbox
                        key="mobile_show_all"
                        name="show_all"
                        label="Show all"
                        checked={value.propertySubType.length === 0}
                        onCheckedChange={() => {
                            onChange({
                                propertySubType: [],
                                propertyType: 'property' as PropertyType
                            });
                        }}
                    />,
                    ...Object.keys(propertySubTypeOptions).map(
                        (propertySubType) => {
                            return (
                                <Checkbox
                                    key={`mobile_${propertySubType}`}
                                    name={propertySubType}
                                    label={
                                        propertySubTypeOptions[
                                            propertySubType as PropertySubType[number]
                                        ]
                                    }
                                    checked={value.propertySubType.includes(
                                        propertySubType as PropertySubType[number]
                                    )}
                                    onCheckedChange={(checked) => {
                                        if (checked) {
                                            const _propertySubType = [
                                                ...value.propertySubType,
                                                propertySubType
                                            ];

                                            onChange({
                                                propertySubType:
                                                    _propertySubType as PropertySubType,
                                                propertyType: getPropertyType(
                                                    _propertySubType as PropertySubType
                                                )
                                            });
                                        } else {
                                            const _propertySubType =
                                                value.propertySubType.filter(
                                                    (i) => i !== propertySubType
                                                );

                                            onChange({
                                                propertySubType:
                                                    _propertySubType,
                                                propertyType:
                                                    getPropertyType(
                                                        _propertySubType
                                                    )
                                            });
                                        }
                                    }}
                                />
                            );
                        }
                    )
                ]}
            </Stack>
        </FilterWrapper>
    );
};
